<template>
  <div>
    <section v-if="!triggerVerification">
      <div class="d-flex flex-column h-100">
        <header class="masthead mb-auto">
          <nav class="navbar navbar-expand-lg">
            <div class="container">
              <a class="navbar-brand" href="/#/">
                <img src="../../assets/img/logo.png" alt="Logo" />
              </a>
              <div class="my-2 my-lg-0">
                <button class="btn btn-light btn-sm my-2 my-sm-0" @click="gotoSingin">
                  Login
                </button>
              </div>
            </div>
          </nav>
        </header>

        <section class="login-container bg-none flex-shrink-0 container">
          <form class="form-signin card mt-4">
            <h5 class="text-center mb-3">Sign up</h5>
            <div class="form-group d-flex tab">
              <button type="button" class="btn btn-block" v-bind:class="{
                'btn-primary': activeTabEmail,
                'btn-outline-primary': activeTabPhone,
              }" @click="showViaEmail">
                Create Via Email
              </button>
              <!-- <button type="button" class="btn btn-block" v-bind:class="{
                'btn-primary': activeTabPhone,
                'btn-outline-primary': activeTabEmail,
              }" @click="showViaPhone">
                Create Via Phone
              </button> -->
            </div>
            <transition name="fade">
              <div class="alert-box-1 mb-4" v-if="showsignupErr">
                <div class="alert-box-cont">
                  <div class="ico pr-3 ico-login-alert">
                    <img src="../../assets/img/warning-24px.svg" alt="" width="30" />
                  </div>
                  <div class="cnt">
                    <p>
                      You’ve entered an email address / phone that is already
                      registered with IBAKATV. If you already are or previously were
                      a member, please Sign In.
                    </p>
                  </div>
                </div>
              </div>
            </transition>
            <div v-if="activeTabEmail">
              <div class="form-group">
                <label for="exampleInputEmail1">Email address</label>
                <input type="text" class="form-control" @focus="removeinvalidemail" id="exampleInputEmail1"
                  v-model="userid" aria-describedby="emailHelp" />
                <label class="text-center pt-3" v-if="invalidemail">Invalid Email</label>
              </div>
            </div>
            <div v-if="activeTabPhone">
              <div class="form-group">
                <label>PHONE NUMBER</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      ({{ countryCode }}) {{ countryName }}
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#" v-for="(countrycode, index) in countrycodes" :key="index"
                        @click="onCountryCodeClicked(countrycode)">({{ countrycode["country_code"] }})
                        {{ countrycode["country_name"] }}</a>
                    </div>
                  </div>
                  <input type="text" class="form-control" v-model="telephone" @focus="phoneFocus"
                    aria-label="Text input with dropdown button" />
                </div>
                <label class="text-center pt-3" v-if="showPhoneValid">Invalid Phone</label>
              </div>
            </div>
            <div class="form-group">
              <label for="exampleInputEmail2">Full Name</label>
              <input type="text" class="form-control" id="exampleInputEmail2" aria-describedby="fullName"
                v-model="fullname" />
            </div>
            <!-- <div class="form-group">
					<label for="exampleInputEmail1">Last Name</label>
					<input
						type="text"
						class="form-control"
						id="exampleInputEmail1"
						aria-describedby="lastname"
						v-model="lastname"
					/>
				</div> -->
            <div class="form-group">
              <label>Password</label>
              <div class="input-group align-items-center" id="show_hide_password">
                <input class="form-control" :type="textInputType" @focus="removeinvalidpassword" v-model="password" />
                <div class="input-group-addon">
                  <a><i class="fa fa-eye-slash" aria-hidden="true" @click="switchPasswordType"></i></a>
                </div>
              </div>
              <label class="text-center pt-3" v-if="showPasswordValid">Password can't be blank</label>
            </div>
            <div class="form-group">
              <label for="exampleInputReferralCode">Enter Referral Code (optional)
              </label>
              <input type="text" class="form-control" id="exampleInputReferralCode" aria-describedby="referralCode"
                v-model="referralCode" />
            </div>

            <div class="custom-control custom-checkbox">
              <input type="checkbox" v-model="checked" class="custom-control-input" id="customCheck1" />
              <label class="custom-control-label text-inharit" for="customCheck1">By signing up, I agree to the ibakatv
                Terms of Use and Privacy
                Policy</label>
            </div>

            <button class="btn btn-primary btn-block text-uppercase mt-3" :disabled="!checked"
              v-on:click.stop.prevent="signup">
              CONTINUE
            </button>
            <label v-if="noService" class="text-center pt-3">Sign Up with Phone is not available please contact to
              Admin</label>
            <label v-if="showsignupErr" class="text-center pt-3">{{
              signupErr
            }}</label>
            <div class="or py-2">
              <hr />
              <span>OR</span>
            </div>
            <button class="btn btn-info btn-block text-uppercase d-flex align-items-center justify-content-center"
              @click="facebookLoginNotification">
              <i class="fa fa-facebook-square mr-2"></i> Sign up with facebook
            </button>
            <small class="text-center pt-3">Sign up for updates from Ibakatv on new releases and promotions.
              Unsubscribe at any time.</small>
          </form>
          <p class="text-center pt-4">Download App</p>
          <p class="text-center">
            <img src="../../assets/img/google-play.png" alt="" class="cursor-pointer" @click="gotoAppStore('google')" />
            <img src="../../assets/img/app-store.png" class="ml-2 cursor-pointer" alt="" @click="gotoAppStore('apple')" />
          </p>
        </section>

        <footer class="footer text-dark mt-auto py-3">
          <div class="container text-center">
            <a href="/#/">Home</a>
            <a href="/#/cookiesprivacy">Privacy Policy</a>
            <a href="/#/terms">Terms of Use</a>
            <a href="/#/faqs">FAQ</a>
          </div>
          <div class="footer-copyright text-center py-2">
            Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
          </div>
        </footer>
      </div>
    </section>
    <section v-if="triggerVerification">
      <EmailVerify :userid="this.userid" :password="this.password" />
    </section>
  </div>
</template>

<style>
nav {
  background-color: var(--navbar-bg-color) !important;
}

.cursor-pointer {
  cursor: pointer;
}

.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #80b440 !important;
  border-color: #80b440 !important;
  pointer-events: none;
  opacity: inherit !important;
}

.alert-box-cont {
  display: flex;
}

.ico-login-alert {
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-box-1 {
  background: #f6e3e4 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 8px;
}

.alert-box-1 p {
  text-align: left;
  letter-spacing: 0px;
  color: #181917;
  opacity: 0.6;
  position: relative;
  margin-bottom: 0px !important;
}

.text-inherit {
  text-decoration: underline;
  color: inherit;
}

.dropdown-menu {
  height: 10rem;
  overflow-y: scroll;
  overflow-x: hidden;
}

.btn-info.disabled {
  pointer-events: none !important;
  background-color: #3a588a !important;
  border-color: #345488 !important;
  color: #f1f2f2 !important;
  opacity: inherit !important;
}
</style>

<script>
import CountryCodes from "@/assets/json/CountryCodes.json";
import EmailVerify from "./checkEmailVerification.vue";
export default {
  name: "signup",
  components: {
    EmailVerify,
  },
  metaInfo: {
    title: "SIGN UP",

  },
  watch: {
    telephone(newval, oldval) {
      if (newval.length > 11) {
        this.telephone = oldval;
      }
    },
  },
  created() {
    this.$store.commit("showPopup", false);
    this.$store.commit("showdefaultFooter", false);
    this.$store.commit("showdefaultnav", false);
    const config = this.$store.getters.getGlobalConfigs;
    var cont = CountryCodes.find((con) => {
      return con.country_name == config.country_code;
    });
    this.countryCode = cont.country_code;
    this.countryName = cont.country_name;
  },
  methods: {
    gotoAppStore(type) {
      if (type == "google") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
          "_blank"
        );
      } else if (type == "apple") {
        window.open(
          "https://apps.apple.com/gm/app/ibakatv/id1060646446",
          "_blank"
        );
      }
    },
    switchPasswordType() {
      this.textInputType =
        this.textInputType == "password" ? "text" : "password";
    },
    emailFocus() {
      this.showEmailValid = false;
    },
    phoneFocus() {
      this.showPhoneValid = false;
    },
    passwordFocus() {
      this.showPasswordValid = false;
    },
    ValidateEmail() {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (this.userid.match(mailformat)) {
        return true;
      } else {
        this.invalidemail = true;
        return false;
      }
    },
    ValidatePhone() {
      var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
      if (this.telephone.match(phoneno)) {
        return true;
      } else {
        this.showPhoneValid = true;
        return false;
      }
    },
    ValidPassword() {
      if (this.password == "") {
        this.showPasswordValid = true;
        return false;
      } else {
        return true;
      }
    },
    removeinvalidemail() {
      this.invalidemail = false;
    },
    removeinvalidpassword() {
      this.showPasswordValid = false;
    },
    gotoSingin() {
      this.$store.commit("logoutUser");
      this.$router.push("/login");
    },
    signUpSuccess() {
      var self = this;
      setTimeout(function () {
        if (self.activeTabPhone) {
          self.$router.push("/verifybyphone");
        }
      }, 7000);
    },
    showViaPhone() {
      this.activeTabEmail = false;
      this.activeTabPhone = true;
      //  this.noService = true;
    },
    showViaEmail() {
      // this.noService = false;
      this.activeTabPhone = false;
      this.activeTabEmail = true;
    },
    showNoService() {
      this.noService = true;
    },
    onCountryCodeClicked(countrycode) {
      this.countryCode = countrycode.country_code;
      this.countryName = countrycode.country_name;
    },
    facebookLoginNotification() {
      // this.$store.commit(
      //   "setNotification",
      //   "Facebook Login Feature Is Coming Soon"
      // );
      FB.login(
        (response) => {
          // handle the response
          const fbAccesToken = response.authResponse.accessToken;
          FB.api("/me", { fields: "email" }, (response) => {
            const fbEmail = response.email;
            var dataToSend = {
              token: fbAccesToken,
              provider: "facebook",
              email: fbEmail,
              slug_name: "1006.test",
            };
            this.$store.commit("setLoader", true);
            this.$store
              .dispatch("socialSignup", dataToSend)
              .then((res) => {
                this.signupSuccessMsg = res.message;
                if (res.user_token != undefined) {
                  this.$store.commit("tempUserToken", res.user_token);
                  this.$store.commit("setBTClientToken", res.clientToken);
                } else if (res.userToken != undefined) {
                  this.$store.commit("tempUserToken", res.userToken);
                  this.$store.commit("setBTClientToken", res.clientToken);
                }
                this.socialLogin(dataToSend);
                this.$store.commit("setLoader", false);
              })
              .catch((err) => {
                this.$store.commit("setLoader", false);
                this.fbSignupErrMsg = err.response.data.error.message;
                this.$store.commit(
                  "setNotification",
                  this.fbSignupErrMsg
                );
              });
          });
        },
        { scope: "public_profile,email" }
      );
    },
    signup() {
      var name = this.fullname.split(" ");

      if (name.length > 1) {
        this.firstname = name[0];
        this.lastname = name[1];
      } else if (name.length <= 1) {
        this.firstname = name[0];
        this.lastname = "";
      }
      if (this.activeTabPhone) {
        if (this.ValidatePhone() == true && this.ValidPassword() == true) {
          if (this.dosignup) {
            var metadata = {
              emailupdate: true,
            };
            var dataToSend = {
              name: this.firstname,
              lastname: this.lastname,
              telephone: this.countryCode + this.telephone,

              password: this.password,
              metaData: metadata,
              referralcode: this.referralCode,
              type: "number",
            };
            this.$store.commit("setLoader", true);
            this.$store
              .dispatch("signup", dataToSend)
              .then((res) => {
                this.signupSuccessMsg = res.message;
                this.firstname = "";
                this.lastname = "";
                this.userid = "";
                this.password = "";
                //this.signupErr= 'Signed up successfully please login'
                this.showsignupErr = true;
                this.checked = false;
                this.$store.commit("userregmobile", dataToSend.telephone);
                if (res.user_token != undefined) {
                  this.$store.commit("tempUserToken", res.user_token);
                  this.$store.commit("setBTClientToken", res.clientToken);
                } else if (res.userToken != undefined) {
                  this.$store.commit("tempUserToken", res.userToken);
                  this.$store.commit("setBTClientToken", res.clientToken);
                }
                this.$store.commit("setRegisterData", dataToSend);
                this.$store.commit("setShowOtpTimer", true);
                this.$router.push("/verifybyphone");
                this.$store.commit("setLoader", false);

                //this.signUpSuccess();
              })
              .catch((err) => {
                this.$store.commit("setLoader", false);
                this.showsignupErr = true;
                this.signupErr = err.response.data.error.message;
              });
          }
        } else {
          this.showPasswordValid = true;
        }
      } else {
        if (this.ValidateEmail(this.userid)) {
          if (this.ValidPassword()) {
            if (this.dosignup) {
              var metadata = {
                emailupdate: true,
              };
              var dataToSend = {
                name: this.firstname,
                lastname: this.lastname,
                email: this.userid,
                telephone: this.telephone,
                password: this.password,
                referralcode: this.referralCode,
                metaData: metadata,
                type: "email",
              };
              this.$store.commit("setLoader", true);
              this.$store
                .dispatch("signup", dataToSend)
                .then((res) => {
                  this.signupSuccessMsg = res.message;
                  this.firstname = "";
                  this.lastname = "";
                  // this.userid = "";
                  // this.password = "";
                  //this.signupErr= 'Signed up successfully please login'
                  this.showsignupErr = true;
                  this.checked = false;
                  this.$store.commit("setBTClientToken", res.clientToken);
                  this.$store.commit("tempUserToken", res.user_token);
                  this.$store.commit("setRegisterData", dataToSend);
                  this.triggerVerification = true;
                  this.$store.commit("setLoader", false);
                })
                .catch((err) => {
                  this.$store.commit("setLoader", false);
                  this.showsignupErr = true;
                  this.signupErr = err.response.data.error.message;
                });
            }
          } else {
            this.showPasswordValid = true;
          }
        } else {
          this.invalidemail = true;
          this.checked = false;
          return false;
        }
      }
      this.isActive = true;
      this.showsignupErr = false;
    },
    socialLogin(dataToSend) {
      var socialLoginData = {
        token: dataToSend.token,
        provider: "facebook",
        email: dataToSend.email,
      }
      this.$store
        .dispatch("socialLogin", socialLoginData)
        .then((res) => {
          this.$store.dispatch("account").then((res) => {
            if (res) {
              this.accountData = res.response;
              if (this.accountData.profile.mobileVerified == false) {
                this.$store.commit(
                  "setNotification",
                  "Please Verify your Phone Number"
                );
              }
              if (this.accountData.subscriptions.length > 0 && this.accountData.subscriptions[0].package_id == this.getText('restriction_package')) {
                this.$store.commit("showSpecialPopUp", true);
              }
              if (this.accountData.subscriptions.length == 0) {
                this.$router.push("/packages");
              }

            }
          });
          this.$store.commit("setuserLoggedIn", true);
          this.$router.push("/home");
          this.$store.commit("setLoader", false);
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.errMsgLogin = err.response.data.error.message;
          this.$store.commit("setNotification", this.errMsgLogin);
        });
    }

  },

  data() {
    return {
      telephone: "",
      activeTabEmail: true,
      textInputType: "password",
      triggerVerification: false,
      checked: false,
      noService: false,
      activeTabPhone: false,
      showsignupErr: false,
      signupSuccess: false,
      passwordmismatch: false,
      signupSuccessMsg: "",
      invalidemail: false,
      showsignupErr: false,
      signupErr: "",
      isActive: false,
      dosignup: true,
      userid: "",
      password: "",
      repassword: "",
      fullname: "",
      firstname: "",
      lastname: "",
      referralCode: null,
      bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
      showEmailValid: false,
      showEmailValidErr: "Invalid Email",
      showPhoneValid: false,
      showPhoneValidErr: "Invalid Phone",
      showPasswordValid: false,
      showPasswordValidErr: "Password can't be blank",
      countrycodes: CountryCodes,
      countryCode: "",
      countryName: "",
      accountData: null,
      errMsgLogin: ""
    };
  },
};
</script>
